import { HomeQuestionCompleteContent } from './HomeQuestionCompleteContent';
export default HomeQuestionCompleteContent;